export default __webpack_public_path__ + "static/media/elasticsearchlogo.045d61ba.png";